<template>
  <footer class="mh-footer mh-footer-3">
    <div class="container-fluid">
      <div class="row section-separator" id="contact">
        <div
          class="col-sm-12 section-title wow fadeInUp"
          data-wow-duration="0.8s"
          data-wow-delay="0.2s"
        >
          <h3>Contact Me</h3>
        </div>
        <div class="map-image image-bg col-sm-12">
          <div class="container mt-30">
            <div class="row">
              <div class="col-sm-6 col-md-6 mh-footer-address">
                <div class="col-sm-12 xs-no-padding">
                  <div
                    class="mh-address-footer-item dark-bg shadow-1 media wow fadeInUp"
                    data-wow-duration="0.8s"
                    data-wow-delay="0.2s"
                  >
                    <div class="each-icon">
                      <i class="fa fa-location-arrow"></i>
                    </div>
                    <div class="each-info media-body">
                      <h4>Work Address</h4>
                      <a :href="$store.getters.getLocation()" target="_blank">
                        <address v-html="$store.getters.getWork" />
                      </a>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 xs-no-padding">
                  <div
                    class="mh-address-footer-item media dark-bg shadow-1 wow fadeInUp"
                    data-wow-duration="0.8s"
                    data-wow-delay="0.4s"
                  >
                    <div class="each-icon">
                      <i class="fa fa-envelope-o"></i>
                    </div>
                    <div class="each-info media-body">
                      <h4>Email</h4>
                      <a :href="`mailto:${$store.getters.getEmail}`">{{
                        $store.getters.getEmail
                      }}</a>
                      <br />
                      <a
                        :href="`mailto:${$store.getters.getSecondaryEmail}`"
                        v-text="$store.getters.getSecondaryEmail"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 xs-no-padding">
                  <div
                    class="mh-address-footer-item media dark-bg shadow-1 wow fadeInUp"
                    data-wow-duration="0.8s"
                    data-wow-delay="0.6s"
                  >
                    <div class="each-icon">
                      <i class="fa fa-phone"></i>
                    </div>
                    <div class="each-info media-body">
                      <h4>Phone</h4>
                      <a
                        :href="`tel:${$store.getters.getPhone}`"
                        v-html="$store.getters.getPhoneStyled"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="col-sm-6 col-md-6 wow fadeInUp"
                data-wow-duration="0.8s"
                data-wow-delay="0.2s"
              >
                <form
                  id="contactForm"
                  class="single-form quate-form wow fadeInUp"
                  data-toggle="validator"
                >
                  <div id="msgSubmit" class="h3 text-center hidden"></div>
                  <div class="row">
                    <div class="col-sm-12">
                      <input
                        name="name"
                        class="contact-name form-control"
                        id="name"
                        v-model="form.first_name"
                        type="text"
                        placeholder="First Name"
                        required
                      />
                    </div>

                    <div class="col-sm-12">
                      <input
                        name="name"
                        class="contact-email form-control"
                        id="L_name"
                        v-model="form.last_name"
                        type="text"
                        placeholder="Last Name"
                      />
                    </div>

                    <div class="col-sm-12">
                      <input
                        name="name"
                        class="contact-subject form-control"
                        id="email"
                        v-model="form.email"
                        type="email"
                        placeholder="Your Email"
                        required
                      />
                    </div>

                    <div class="col-sm-12">
                      <textarea
                        class="contact-message"
                        id="message"
                        v-model="form.message"
                        rows="6"
                        placeholder="Your Message"
                        required
                      ></textarea>
                    </div>

                    <!-- Subject Button -->
                    <div class="btn-form col-sm-12">
                      <button
                        type="submit"
                        class="btn btn-fill btn-block"
                        id="form-submit"
                        @click.prevent="sendMail"
                      >
                        Send Message
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              <div
                class="col-sm-6 mh-copyright wow fadeInUp"
                data-wow-duration="0.8s"
                data-wow-delay="0.2s"
              >
                <div class="row">
                  <div class="col-sm-6">
                    <div class="text-left text-xs-center">
                      <p>
                        All right reserved
                        {{ $store.getters.getFirstName }} @{{
                          new Date().getFullYear()
                        }}
                      </p>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <ul class="social-icon">
                      <li
                        v-show="
                          $store.getters.getTwitter != '' ||
                          typeof $store.getters.getTwitter == 'undefined'
                        "
                      >
                        <a :href="$store.getters.getTwitter" target="_blank">
                          <i class="fa fa-twitter"></i>
                        </a>
                      </li>

                      <li
                        v-show="
                          $store.getters.getLinkedIn != '' ||
                          typeof $store.getters.getLinkedIn == 'undefined'
                        "
                      >
                        <a :href="$store.getters.getLinkedIn" target="_blank">
                          <i class="fa fa-linkedin"></i>
                        </a>
                      </li>

                      <li
                        v-show="
                          $store.getters.getGithub != '' ||
                          typeof $store.getters.getGithub == 'undefined'
                        "
                      >
                        <a :href="$store.getters.getGithub" target="_blank">
                          <i class="fa fa-github"></i>
                        </a>
                      </li>

                      <li
                        v-show="
                          $store.getters.getFacebook != '' ||
                          typeof $store.getters.getFacebook == 'undefined'
                        "
                      >
                        <a :href="$store.getters.getFacebook" target="_blank">
                          <i class="fa fa-facebook"></i>
                        </a>
                      </li>

                      <li
                        v-show="
                          $store.getters.getDribble != '' ||
                          typeof $store.getters.getDribble == 'undefined'
                        "
                      >
                        <a :href="$store.getters.getDribble" target="_blank">
                          <i class="fa fa-dribbble"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      form: {
        first_name: null,
        last_name: null,
        email: null,
        message: null,
      },
      hypen: "-",
    };
  },
  computed: {
    validated() {
      if (this.form.first_name == "" || this.form.first_name == null) {
        this.$toast.fire({
          icon: "error",
          title: "Whoops! I'll need your name.",
        });
        return false;
      }
      if (this.form.email == "" || this.form.email == null) {
        this.$toast.fire({
          icon: "error",
          title: "Input a valid E-mail Address.",
        });
        return false;
      }

      if (this.form.message == "" || this.form.message == null) {
        this.$toast.fire({
          icon: "error",
          title: "Whoops! Spamming not allowed!",
        });
        return false;
      }

      return true;
    },
  },
  methods: {
    sendMail(event) {
      if (this.validated == true) {
        let runTime = 0; // Initialize the number of times to run
        event.target.disabled = true; // Disable the button, to avoid spamming
        setInterval(
          function () {
            if (runTime < 14) {
              event.target.innerText = `Loading ${this.hypen}`; // Update the innerText
              this.hypen = this.hypen + ".-"; // Add new values
            } else event.target.innerText = "Send Message";
            runTime++; // Increament the "runtime" value
          }.bind(this), // Bind the "this" object
          300
        );
        this.$emailjs
          .send(
            "default_service",
            "contact_me",
            {
              dev: process.env.VUE_APP_AUTHOR,
              first_name: this.form.first_name,
              last_name: this.form.last_name,
              email: this.form.email,
              message: this.form.message,
            },
            process.env.VUE_APP_EMAILJS_USER_ID
          )
          .then((response) => {
            if (response.status == 200) {
              this.$toast.fire({
                icon: "success",
                title: "I'll send a reply ASAP.",
              });
              this.reset(event);
            }
          })
          .catch((e) => {
            this.$toast.fire({
              icon: "error",
              title: "Oops!...Poor connection",
            });
          });
      }
    },

    reset(event) {
      this.form.first_name = null;
      this.form.last_name = null;
      this.form.email = null;
      this.form.message = null;
      this.hypen = "-";
      event.target.disabled = false; // Enable the button
    },
  },
};
</script>

<style>
/* For Small devices and Tablets */
@media only screen and (min-width: 577px) and (max-width: 767px) {
  .mh-footer-address .each-icon {
    display: none;
  }
  .mh-footer-address .each-info.media-body {
    padding-left: 0px !important;
    padding-bottom: 15px !important;
  }
}
</style>
